<template>
  <div class="container" v-loading="loading">
      <!-- 搜索栏 -->
      <div class="search-bar">
      <el-button class="add-btn" icon="el-icon-plus" @click="addItem" v-if="website.roleType === 'factory' && type === 'common'">{{$t('faultList.addFault')}}</el-button>
      <div class="right">
        <el-autocomplete
            v-model="filterObj.alarmType"
            :fetch-suggestions="function (queryString, cb) { return querySearchAsync(queryString, cb, 'alarmType') }"
            :trigger-on-focus="false"
            clearable
            value-key="alarmType"
            :placeholder="$t('faultList.inputFaultType')"
            @select="function (item) { return handleKeywordSelect(item, 'alarmType') }"
            @keyup.enter.native="search"
            >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <button slot="append" class="search-btn" @click="search">{{$t('tagsView.search')}}</button>
        </el-autocomplete>
        <div class="advance-filter">
          <i class="iconfont icon-shaixuan"></i>
          <span class="title" @click="showDrawer">{{$t('complaintList.highSearch')}}</span>
        </div>
      </div>
   </div>
   <!-- 列表 -->
  <div class="empty_" v-if="!dataSource.length">
      <el-empty :description="$t('complaintList.noData')"></el-empty>
   </div>
   <div class="list" v-else>
      <div class="list-item"
      v-for="(item, index) in dataSource"
      :key="index"
      @click="toDetail(item.id)"
      >
        <div class="top">
          <i class="el-icon-collection-tag title-icon"></i>
          <span class="title">{{ item.alarmType }}</span>
        </div>
        <div class="mid">
           <div class="user">
            <img :src="dataSource.createUserAvatar" alt="" v-if="dataSource.createUserAvatar" class="avatar" />
            <img src="@/assets/img/avatar.png" alt="" v-else class="avatar" />
             <span class="user-name">{{ item.createUserName }}</span>
           </div>
           <p class="time">{{ item.createTime }}</p>
        </div>
        <div class="bottom">
         <div class="type" v-if="item.attach">
                                    <img :src="item.resource" alt="" />
                                </div>
          <p class="content">{{ item.solution }}</p>
        </div>
      </div>
   </div>
  <div class="pagination_">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="listReq.current"
      :page-sizes="[20, 40, 60, 80, 100]"
      :page-size="listReq.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listReq.total">
    </el-pagination>
    </div>
    <FilterDrawer
    @faction="faction"
    :defaultInfo="currentInfo"
    v-if="drawerVisible"
    :visible.sync="drawerVisible"
    />
  </div>
</template>

<script>
import {
  getCommonFaultPage,
  getTempFaultPage,
  getCommonType,
  getTempType
  } from "@/api/fault";
  import FilterDrawer from "./components/filter.vue"
import website from "@/config/website";

import { onfileResourceChange, matchFileType, formatByte } from "@/util/fileType"
  export default {
    components: {
      FilterDrawer
    },
    data() {
      return {
        listApi: null,
        searchApi: null,
        searchList: [],
        dataSource: [],
        filterObj: {
          alarmType: '',
          startTime: '',
          endTime: '',
          createUserObj: {
            name: '',
            code: ''
          },
          productList: []
        },
        loading: false,
        drawerVisible: false,
        currentInfo: {}
      }
    },
    computed: {
      listReq() {
        return {
          current: 1,
          size: 20,
          total: 0,
          uploadType:0,
          alarmType: this.filterObj.alarmType,
          startTime: this.filterObj.startTime, // 开始时间
          endTime: this.filterObj.endTime, // 结束时间
          createUser: this.filterObj.createUserObj.code, // 创建人
          productList: this.filterObj.productList // 关联产品
        }
      },
      type() {
        if(this.$route.meta && this.$route.meta.type) {
          return this.$route.meta.type;
        }
      },
      website() {
        return website;
      }
    },
    created() {
      this.getList();
      this.getSearchList();
    },
    methods: {
      faction(e) {
        console.log(e);
        this.filterObj.startTime = e && e.time ? e.time[0] : '';
        this.filterObj.endTime = e && e.time ? e.time[1] : '';
        this.filterObj.productList = e && e.product ? e.product.join(",") : [];
        this.filterObj.createUserObj.code = e && e.code ? e.code : '';
        this.filterObj.createUserObj.name = e && e.name ? e.name : '';
        this.getList();
      },
      showDrawer() {
        this.currentInfo.productList = this.filterObj.productList;
        // this.currentInfo.createUserObj = this.filterObj.createUserObj;
        this.currentInfo.startTime = this.filterObj.startTime;
        this.currentInfo.endTime = this.filterObj.endTime;
        this.drawerVisible = true;
      },
      handleListApiChange(e) {
        switch(e) {
          case 'common':
            return getCommonFaultPage;
          case 'temp':
            return getTempFaultPage;
        }
      },
      handleSearchApiChange(e) {
        switch(e) {
          case 'common':
            return getCommonType;
          case 'temp':
            return getTempType;
        }
      },
      handleRouterNameChange(e) {
        switch(e) {
          case 'common':
            return 'alarmCommonExplain';
          case 'temp':
            return 'alarmTempExplain';
        }
      },
      querySearchAsync(queryString, cb, target) {
        console.log('target', target);
        var searchList = this.searchList;
        var results = queryString ? searchList.filter(this.createStateFilter(queryString, target)) : searchList;
        console.log(results);
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 3000 * Math.random());
      },
      createStateFilter(queryString, target) {
        return (state) => {
            console.log(state);
          return (state[target].toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleKeywordSelect(item, key) {
        console.log(item[key]);
        this.filterObj.alarmType = item[key];
        this.getList();
      },
      search() {
        this.getList();
      },
      addItem() {
        this.$router.push({
          path: `/service/${this.handleRouterNameChange(this.type)}-new`,
        })
      },
      toDetail(id) {
        this.$router.push({
          path: `/service/${this.handleRouterNameChange(this.type)}-detail`,
          query: {
            id
          }
        })
      },
      handleSizeChange(val) {
        console.log(this.$t('complaintList.everyPage') + `${val}` + this.$t('complaintList.bar'));
        this.listReq.size = val;
        this.getList();
      },
      handleCurrentChange(val) {
        console.log(this.$t('complaintList.momentPage') + `: ${val}`);
        this.listReq.current = val;
        this.getList();
      },
      async getList() {
        try {
          this.loading = true;
          this.listApi = this.handleListApiChange(this.type);
          const res = await this.listApi(this.listReq);
          console.log('res =>', res.data);
          if(res.data && res.data.code === 200) {
            this.dataSource = res.data.data.records;
            this.dataSource.map(item=>{
               item.resource = onfileResourceChange(matchFileType(item.attach))
            })
            this.listReq.total = res.data.data.total;
          }
          this.loading = false;
        } catch(e) {
          this.loading = false;
          console.log(e);
        }
      },
      async getSearchList() {
        try {
          this.searchApi = this.handleSearchApiChange(this.type);
          const res = await this.searchApi();
          if(res.data && res.data.code === 200) {
            let data = res.data.data;
            data && data.map(x => {
              this.searchList.push({
                alarmType: x
              })
            })
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.container {
    background-color: #f0f2f5;
    height: 100%;
    overflow: auto;
}
.search-bar {
    display: flex;
    justify-content: space-between;
    padding: 0 19px;
    align-items: center;
    min-height: 64px;
    background: #FFFFFF;
    box-shadow: 0 2px 8px 0 rgba(30, 85, 255, 0.1);
    border-radius: 4px;
    .add-btn {
        background: #50C4CB;
        color: #fff;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }
    .right {
        display: flex;
        align-items: center;
        .advance-filter {
            margin-left: 25px;
            .title {
              margin-left: 8px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
            }
        }
        .search-btn {
            background: #59CFD6;
            border: none;
            color: #fff;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
        }
        .advance-filter:hover {
            cursor: pointer;
            color: #59CFD6;
        }
    }
    /deep/ .el-autocomplete input {
        border-color: #59CFD6;
    }
    /deep/ .el-input-group__append {
        background-color: #59CFD6;
    }
}
.list {
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(30, 85, 255, 0.1);
  margin-top: 20px;
  .list-item {
    padding: 22px 20px;
    border-bottom: 1px solid #E5E5E5;
    .top {
      .title-icon {
        font-size: 18px;
        color: #50C4CB;
      }
      .title {
        margin-left: 12px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
      .title:hover {
        text-decoration: underline;
      }
    }
    .mid {
      display: flex;
      align-items: center;
      margin-top: 21px;
      .user {
        display: flex;
        align-items: center;
        .avatar {
          width: 14px;
          height: 14px;
        }
        .user-name {
          margin-left: 8px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
        }
      }
      .time {
        margin-left: 44px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }
    }
    .bottom {
      margin-top: 18px;display:flex; justify-content: start;
      .type{
        img{width: 24px;height: 24px;}
      }
      .content {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
      }
    }
  }
  .list-item:hover {
    cursor: pointer;
  }
}
.pagination_ {
    position: fixed;
    right: 23px;
    bottom: 24px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #01AAA7;
}
</style>
